import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import React, { useEffect, useRef } from 'react'
import { BsX } from 'react-icons/bs'
import { AL_INFO, defaultSelectData, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import FooterUserInfoAdmin from './FooterUserInfoAdmin'
import UserInfoPreview from './UserInfoPreview'

const FooterNormal = ({ close }) => {
    return (
        <Flex w="full" justify="center">
            <Button leftIcon={<BsX />} colorScheme="blue" onClick={close}>
                ปิดหน้าต่าง
            </Button>
        </Flex>
    )
}

const ModalUserInfo = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_INFO && data?.id) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>ข้อมูลบัญชีผู้ใช้</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {data?.id && <UserInfoPreview uid={data?.id} />}
                </ModalBody>
                <ModalFooter>
                    {[1, 2].includes(data?.id) ? <FooterNormal close={onCloseHandle} /> : <FooterUserInfoAdmin close={onCloseHandle} />}
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalUserInfo
